import type { Comparison, ComparisonRow } from "@/types/paper";

function shorthand(row: ComparisonRow): string {
  const lastName =
    (row.authors[0] ?? "Unknown").split(",")[0].split(" ").pop() ?? "Unknown";
  return row.year != null ? `${lastName} ${row.year}` : lastName;
}

function escapeCell(s: string): string {
  return s.replace(/\|/g, "\\|");
}

export function comparisonToMarkdown(comparison: Comparison): string {
  const cols = [...comparison.columns, ...comparison.custom_columns];
  const header = `| Paper | ${cols.join(" | ")} |`;
  const sep = `| --- | ${cols.map(() => "---").join(" | ")} |`;
  const rows = comparison.rows.map((r) => {
    const cells = cols.map((c) => escapeCell(r.columns[c] ?? "—"));
    return `| ${shorthand(r)} | ${cells.join(" | ")} |`;
  });
  const tableMd = [header, sep, ...rows].join("\n");
  return comparison.synthesis ? `${tableMd}\n\n${comparison.synthesis}` : tableMd;
}
